module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodrain-52f71f6393491a26144bdb716678d093.svg";